

import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor} from '@angular/common/http';
import { Observable, throwError, catchError } from 'rxjs';
import { ErrorService } from '../services/error.service';
import { SKIP_GLOBAL_HTTP_UI } from './skip-global-http-ui.token';


@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {
  constructor(public errorService: ErrorService, ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.context.get(SKIP_GLOBAL_HTTP_UI)) {
      return next.handle(request);
    }

    return next.handle(request).pipe(
      catchError((error: any) => {
        if (error && error.error ) {
         this.errorService.setError(error.error.message);
       } else {
          this.errorService.setError(error.message);
       }
       return throwError(() => error);

        // }
      })
    );
  }

}
